import { createFileRoute } from "@tanstack/react-router";
import { FabricatePage } from "@/features/fabricate/page";

export const Route = createFileRoute("/_app/fabricate/")({
  component: FabricatePage,
});
